import React from "react";

export const Input = React.forwardRef(({
  name,
  type = "text",
  placeholder,
  value,
  label,
  onChange,
  className = "",
  id,
  autoComplete,
  error,
  required,
  ...props
}, ref) => {
  const inputId = id || name;
  const hasError = error && error.length > 0;

  return (
    <div>
      {label && (
        <label
          htmlFor={inputId}
           style={{ color: 'var(--text-primary)' }}
          className={`mb-1 block font-medium ${hasError ? 'text-red-700' : 'text-gray-700'}`}
        >
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <input
        ref={ref}
        id={inputId}
        name={name}
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        autoComplete={autoComplete}
        className={`
          w-full rounded-lg border px-3 py-2 focus:ring-1 focus:outline-none transition-colors
          ${hasError
            ? 'border-red-300 bg-red-50 text-red-900 focus:border-red-500 focus:ring-red-500'
            : 'border-gray-300 bg-white text-gray-900 focus:border-blue-500 focus:ring-blue-500'
          }
          ${className}
        `}
        {...props}
      />
      {hasError && (
        <p className="mt-1 text-sm text-red-600">
          {error}
        </p>
      )}
    </div>
  );
});

Input.displayName = 'Input';
